export default __webpack_public_path__ + "static/media/success.07b65c55.svg";